import { Link } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { MapPin, Phone, Mail, Facebook, Instagram, Twitter } from "lucide-react";

const Footer = () => {
  const { categories, settings } = useApp();

  return (
    <footer className="footer-dark py-16 mt-16" data-testid="main-footer">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block mb-6" data-testid="footer-logo">
              <span className="text-2xl font-bold text-primary">Mini</span>
              <span className="text-2xl font-bold text-white">Begum</span>
              <span className="text-2xl font-bold text-accent">Bazaar</span>
            </Link>
            <p className="text-sm text-gray-400 mb-6 leading-relaxed">
              Your one-stop shop for all fancy items, fashion, electronics, groceries, and more. 
              Quality products at affordable prices.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-primary transition-colors" data-testid="social-facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-primary transition-colors" data-testid="social-instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-primary transition-colors" data-testid="social-twitter">
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Categories</h4>
            <ul className="space-y-3">
              {categories.slice(0, 6).map((category) => (
                <li key={category.id}>
                  <Link 
                    to={`/category/${category.slug}`} 
                    className="text-sm text-gray-400 hover:text-primary transition-colors"
                    data-testid={`footer-category-${category.slug}`}
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm text-gray-400 hover:text-primary transition-colors" data-testid="footer-link-home">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/categories" className="text-sm text-gray-400 hover:text-primary transition-colors" data-testid="footer-link-categories">
                  All Categories
                </Link>
              </li>
              <li>
                <Link to="/cart" className="text-sm text-gray-400 hover:text-primary transition-colors" data-testid="footer-link-cart">
                  Shopping Cart
                </Link>
              </li>
              <li>
                <Link to="/track-order" className="text-sm text-gray-400 hover:text-primary transition-colors" data-testid="footer-link-track">
                  Track Order
                </Link>
              </li>
              <li>
                <Link to="/my-account" className="text-sm text-gray-400 hover:text-primary transition-colors" data-testid="footer-link-account">
                  My Account
                </Link>
              </li>
              <li>
                <Link to="/admin" className="text-sm text-gray-400 hover:text-primary transition-colors" data-testid="footer-link-admin">
                  Admin Panel
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                <span className="text-sm text-gray-400">
                  {settings?.store_address || "123 Bazaar Street, Mini Begum Nagar, India - 500001"}
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-primary flex-shrink-0" />
                <span className="text-sm text-gray-400">{settings?.store_phone || "+91 94411 14344"}</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-primary flex-shrink-0" />
                <span className="text-sm text-gray-400">{settings?.store_email || "contact@minibegumbazaar.com"}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-500">
            © 2024 MiniBegumBazaar. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-sm text-gray-500 hover:text-gray-300 transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-sm text-gray-500 hover:text-gray-300 transition-colors">
              Terms of Service
            </a>
            <a href="#" className="text-sm text-gray-500 hover:text-gray-300 transition-colors">
              Refund Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
